<template>
  <div></div>
</template>

<script>
  import runtimeConfig from '@/common/runtime-config';
  import { PERMISSION_CHECKS_ACTIONS_NAME } from '@/common/store/permissionChecks/name';

  import { redirectToBlitzLogout } from '@/modules/auth/utils/pkce';

  import store from '@/store/index';

  export default {
    name: 'Logout',
    async created() {
      store.dispatch(PERMISSION_CHECKS_ACTIONS_NAME.resetPermissionChecks);
      store.dispatch('auth/oidc/logout');

      redirectToBlitzLogout(runtimeConfig.oidc);
    },
  };
</script>
